

import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import React, { useState } from "react";
import jsFileDownload from "js-file-download";
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { toast } from "../../../../toast";
import {useParams} from "react-router-dom";
import { Log } from "@tensorflow/tfjs";
// PDF Document for download
const PDFDocument = ({ students, moduleName }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <Text style={pdfStyles.title}>{moduleName} - Attendance Report</Text>
      <View style={pdfStyles.tableHeader}>
        <Text style={pdfStyles.headerCell}>Name</Text>
        <Text style={pdfStyles.headerCell}>Roll No</Text>
        <Text style={pdfStyles.headerCell}>No. of Qs</Text>
        <Text style={pdfStyles.headerCell}>No. of Qs Attended</Text>
        <Text style={pdfStyles.headerCell}>Cluster</Text>
      </View>
      {students.map((student, idx) => (
        <View style={pdfStyles.tableRow} key={idx}>
          <Text style={pdfStyles.cell}>{student.name}</Text>
          <Text style={pdfStyles.cell}>{student.roll}</Text>
          <Text style={pdfStyles.cell}>15</Text>
          <Text style={pdfStyles.cell}>15</Text>
          <Text style={pdfStyles.cell}>{student.cluster || "B26 Batch 9"}</Text>
        </View>
      ))}
    </Page>
  </Document>
);

const pdfStyles = StyleSheet.create({
  page: { padding: 30 },
  title: { fontSize: 18, marginBottom: 20, textAlign: "center", fontWeight: "bold" },
  tableHeader: { flexDirection: "row", borderBottom: 1, borderBottomColor: "#000", marginBottom: 8 },
  headerCell: { flex: 1, fontWeight: "bold", fontSize: 12 },
  tableRow: { flexDirection: "row", borderBottom: 1, borderBottomColor: "#eee" },
  cell: { flex: 1, fontSize: 10, paddingVertical: 2 },
});

function downloadCSV(students, moduleName) {
  const csvRows = [
    ["Name", "Roll No", "No. of Qs", "No. of Qs Attended", "Cluster"],
    ...students.map(s => [s.name, s.roll, 15, 15, s.cluster || "B26 Batch 9"])
  ];
  const csvContent = csvRows.map(row => row.join(",")).join("\n");
  jsFileDownload(csvContent, `${moduleName}-attendance.csv`);
  toast.success("CSV downloaded!");
}

function handleSendEmail(students, moduleName) {
  // Dummy implementation
  toast.info("Share functionality is a placeholder in this demo.");
}

// Dummy data
// Dummy data fallback
const dummyCluster = "B26 Batch 9";
const dummyModule = "Array Basics";
const totalDays = 15;

const dummyAttended = [
  { name: "Dhana Sekar V", roll: "B26CS001", email: "dhana@example.com" },
  { name: "ABDUL HASEEB S", roll: "B26CS002", email: "abdul@example.com" },
  { name: "Taruun Prasath G S", roll: "B26CS003", email: "taruun@example.com" },
  { name: "Thiruvarasu R", roll: "B26CS004", email: "thiru@example.com" },
];
const dummyNotAttended = [
  { name: "Vishaka Dheshini G", roll: "B26CS005", email: "vishaka@example.com" },
  { name: "DHIVYADHARSHINI M", roll: "B26CS006", email: "dhivya@example.com" },
  { name: "PURNIMA S", roll: "B26CS007", email: "purnima@example.com" },
  { name: "Kanojsairam", roll: "B26CS008", email: "kanoj@example.com" },
];
const dummyDayWise = [
  {
    date: "2025-07-01",
    attended: [dummyAttended[0], dummyAttended[1]],
    notAttended: [dummyAttended[2], dummyAttended[3]],
  },
  {
    date: "2025-07-02",
    attended: [dummyNotAttended[0]],
    notAttended: [dummyNotAttended[1], dummyNotAttended[2]],
  },
  // ...more days
];


const ReportList = ({ cluster, module, attended, notAttended, dayWise }) => {
 
  
  const [selectedDay, setSelectedDay] = useState(0);
  // view: 0: main, 1: attended, 2: not attended, 3: daywise attended, 4: daywise not attended
  // viewTab: 0: overall, 1: daywise
  const [view, setView] = useState(1); // Default to attended report
  const [viewTab, setViewTab] = useState(0);

  // Use props if provided, else fallback to dummy data
  const clusterName = cluster || dummyCluster;
  const moduleName = module || dummyModule;
  const attendedList = attended || dummyAttended;
  const notAttendedList = notAttended || dummyNotAttended;
  const dayWiseList = dayWise || dummyDayWise;
  const { campusName } = useParams(); 

  

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-8">
        {/* Switch Tab for Overall/Day-wise */}
        <div className="flex flex-row justify-center mb-8">
          <button
            className={`px-6 py-2 rounded-l-lg font-semibold border border-blue-400 focus:outline-none transition-colors duration-150 ${viewTab === 0 ? 'bg-blue-500 text-white' : 'bg-white text-blue-700 hover:bg-blue-50'}`}
            onClick={() => { setViewTab(0); setView(1); }}
          >
            Overall
          </button>
          <button
            className={`px-6 py-2 rounded-r-lg font-semibold border-t border-b border-r border-blue-400 focus:outline-none transition-colors duration-150 ${viewTab === 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-700 hover:bg-blue-50'}`}
            onClick={() => { setViewTab(1); setView(3); }}
          >
            Day-wise
          </button>
        </div>
        {/* Show only the relevant card and report based on tab */}
        {viewTab === 0 && (
          <>
            <div className="flex justify-center mb-10">
              <div className="relative flex flex-col justify-between h-full p-0 bg-white rounded-2xl min-w-[420px] md:min-w-[560px] max-w-[620px] overflow-hidden shadow-lg">
                <div className="flex flex-row items-center justify-between px-8 pt-8 pb-2">
                  <span className="text-lg font-bold tracking-wide text-blue-700">Module</span>
                  <span className="px-4 py-1 text-sm font-bold text-blue-600 bg-blue-100 rounded-full shadow">{moduleName}</span>
                </div>
                <div className="flex flex-row items-center justify-center gap-10 px-8 pt-2 pb-8">
                  <div className="flex flex-col items-center min-w-[80px]">
                    <span className="text-4xl font-extrabold text-blue-700">{attendedList.length}</span>
                    <span className="mt-1 text-sm font-medium text-blue-700">Attended</span>
                  </div>
                  <div className="flex flex-col items-center min-w-[80px]">
                    <span className="text-4xl font-extrabold text-rose-600">{notAttendedList.length}</span>
                    <span className="mt-1 text-sm font-medium text-rose-600">Not Attended</span>
                  </div>
                  <div className="flex flex-col items-center min-w-[80px]">
                    <span className="mb-1 text-xs font-semibold text-gray-500">Total Days</span>
                    <span className="text-2xl font-bold text-blue-700">{totalDays}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Attended/Not Attended Tab Switch BELOW the box */}
            <div className="flex flex-row justify-center mb-4">
              <button
                className={`px-6 py-2 rounded-l-lg font-semibold border border-blue-400 focus:outline-none transition-colors duration-150 ${view === 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-700 hover:bg-blue-50'}`}
                onClick={() => setView(1)}
              >
                Attended
              </button>
              <button
                className={`px-6 py-2 rounded-r-lg font-semibold border-t border-b border-r border-blue-400 focus:outline-none transition-colors duration-150 ${view === 2 ? 'bg-blue-500 text-white' : 'bg-white text-blue-700 hover:bg-blue-50'}`}
                onClick={() => setView(2)}
              >
                Not Attended
              </button>
            </div>
          </>
        )}
        {viewTab === 1 && (
          <>
            <div className="flex justify-center mb-10">
              <div className="relative flex flex-col justify-between h-full p-0 bg-white rounded-2xl min-w-[420px] md:min-w-[560px] max-w-[620px] overflow-hidden shadow-lg">
                <div className="flex flex-row items-center justify-between px-8 pt-8 pb-2">
                  <span className="text-lg font-bold tracking-wide text-blue-700">Day-wise</span>
                  <span className="px-3 py-1 text-xs font-bold text-blue-600 bg-blue-100 rounded-full shadow">{dayWiseList[selectedDay]?.date || '--'}</span>
                </div>
                <div className="flex flex-row items-center justify-between px-8 pt-2 pb-8">
                  <div className="flex flex-col items-center">
                    <span className="text-3xl font-extrabold text-blue-700">{dayWiseList[selectedDay]?.attended?.length || 0}</span>
                    <span className="mt-1 text-xs font-medium text-blue-700">Attended</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <span className="text-3xl font-extrabold text-rose-600">{dayWiseList[selectedDay]?.notAttended?.length || 0}</span>
                    <span className="mt-1 text-xs font-medium text-rose-600">Not Attended</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <span className="mb-1 text-xs font-semibold text-gray-500">Select Day</span>
                    <div className="relative w-48">
                      <select
                        className="block w-full px-4 py-2 pr-12 text-base font-medium text-blue-800 transition-all duration-200 border border-gray-200 shadow appearance-none bg-gradient-to-br from-white via-blue-50 to-white rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:bg-white hover:border-blue-300"
                        value={selectedDay}
                        onChange={e => setSelectedDay(Number(e.target.value))}
                        style={{ WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none' }}
                      >
                        {dayWiseList.map((day, idx) => (
                          <option value={idx} key={day.date}>{day.date}</option>
                        ))}
                      </select>
                      <span className="absolute inset-y-0 flex items-center text-blue-500 pointer-events-none right-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <rect x="3" y="5" width="18" height="16" rx="4" fill="#fff" stroke="#3b82f6" strokeWidth="1.5"/>
                          <rect x="7" y="2.5" width="2" height="4" rx="1" fill="#3b82f6"/>
                          <rect x="15" y="2.5" width="2" height="4" rx="1" fill="#3b82f6"/>
                          <rect x="7" y="10" width="2" height="2" rx="1" fill="#3b82f6"/>
                          <rect x="11" y="10" width="2" height="2" rx="1" fill="#3b82f6"/>
                          <rect x="15" y="10" width="2" height="2" rx="1" fill="#3b82f6"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Removed Attended/Not Attended Tab Switch for daywise as per request */}
          </>
        )}

       
        {viewTab === 0 && (
          <>
            {view === 1 ? (
              <div className="p-8 mb-10 bg-white shadow-lg rounded-xl">
                <div className="flex flex-row items-center justify-between mb-6">
                  <span className="inline-block px-3 py-1 text-lg font-bold text-blue-700 rounded-full">Attended Students</span>
                  <div className="flex flex-row justify-end gap-4">
                    <button
                      className="px-6 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
                      onClick={() => downloadCSV(attendedList, moduleName)}
                    >Download CSV</button>
                    <PDFDownloadLink
                      document={<PDFDocument students={attendedList} moduleName={moduleName} />}
                      fileName={`${moduleName}-attendance.pdf`}
                    >
                      {({ loading }) => (
                        <button className="px-6 py-2 font-semibold text-white bg-green-500 rounded hover:bg-green-600">
                          {loading ? "Loading..." : "Download PDF"}
                        </button>
                      )}
                    </PDFDownloadLink>
                    <button
                      className="px-6 py-2 font-semibold text-white bg-purple-500 rounded hover:bg-purple-600"
                      onClick={() => handleSendEmail(attendedList, moduleName)}
                    >Share Now</button>
                  </div>
                </div>
                <div id="attended-table">
                  <table className="w-full text-sm text-left text-gray-700">
                    <thead>
                      <tr className="text-xs text-gray-500 uppercase bg-blue-50">
                        <th className="px-2 py-2">S.No</th>
                        <th className="px-2 py-2">Name</th>
                        <th className="px-2 py-2">Roll No</th>
                        <th className="px-2 py-2">No. of Qs</th>
                        <th className="px-2 py-2">No. of Qs Attended</th>
                        <th className="px-2 py-2">Cluster</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendedList.map((student, idx) => (
                        <React.Fragment key={idx}>
                          <tr className="hover:bg-blue-50">
                            <td className="px-2 py-2 font-bold text-center">{idx + 1}</td>
                            <td className="px-2 py-2 font-medium">{student.name}</td>
                            <td className="px-2 py-2">{student.roll}</td>
                            <td className="px-2 py-2 text-center">15</td>
                            <td className="px-2 py-2 text-center">15</td>
                            <td className="px-2 py-2">{clusterName}</td>
                          </tr>
                          <tr>
                            <td colSpan={6}><hr className="border-gray-200 my-0.5" /></td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="p-8 mb-10 bg-white shadow-lg rounded-xl">
                <div className="flex flex-row items-center justify-between mb-6">
                  <span className="inline-block px-3 py-1 text-lg font-bold text-blue-700 rounded-full">Not Attended Students</span>
                  <div className="flex flex-row justify-end gap-4">
                    <button
                      className="px-6 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
                      onClick={() => downloadCSV(notAttendedList, moduleName)}
                    >Download CSV</button>
                    <PDFDownloadLink
                      document={<PDFDocument students={notAttendedList} moduleName={moduleName} />}
                      fileName={`${moduleName}-not-attended.pdf`}
                    >
                      {({ loading }) => (
                        <button className="px-6 py-2 font-semibold text-white bg-green-500 rounded hover:bg-green-600">
                          {loading ? "Loading..." : "Download PDF"}
                        </button>
                      )}
                    </PDFDownloadLink>
                    <button
                      className="px-6 py-2 font-semibold text-white bg-purple-500 rounded hover:bg-purple-600"
                      onClick={() => handleSendEmail(notAttendedList, moduleName)}
                    >Share Now</button>
                  </div>
                </div>
                <div id="not-attended-table">
                  <table className="w-full text-sm text-left text-gray-700">
                    <thead>
                      <tr className="text-xs text-gray-500 uppercase bg-blue-50">
                        <th className="px-2 py-2">S.No</th>
                        <th className="px-2 py-2">Name</th>
                        <th className="px-2 py-2">Roll No</th>
                        <th className="px-2 py-2">No. of Qs</th>
                        <th className="px-2 py-2">No. of Qs Attended</th>
                        <th className="px-2 py-2">Cluster</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notAttendedList.map((student, idx) => (
                        <React.Fragment key={idx}>
                          <tr className="hover:bg-blue-50">
                            <td className="px-2 py-2 font-bold text-center">{idx + 1}</td>
                            <td className="px-2 py-2 font-medium">{student.name}</td>
                            <td className="px-2 py-2">{student.roll}</td>
                            <td className="px-2 py-2 text-center">15</td>
                            <td className="px-2 py-2 text-center">15</td>
                            <td className="px-2 py-2">{clusterName}</td>
                          </tr>
                          <tr>
                            <td colSpan={6}><hr className="border-gray-200 my-0.5" /></td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
        {viewTab === 1 && view === 3 && (
          <div className="p-8 mb-10 bg-white shadow-lg rounded-xl">
            <div className="flex flex-row items-center justify-between mb-6">
              <span className="inline-block px-3 py-1 text-lg font-bold text-blue-700 rounded-full">Daywise Attended Students</span>
              <div className="flex flex-row justify-end gap-4">
                <button
                  className="px-6 py-2 font-semibold text-white bg-blue-900 rounded hover:bg-blue-800"
                  onClick={() => setView(4)}
                >Not Attended</button>
                <button
                  className="px-6 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
                  onClick={() => downloadCSV(dayWiseList[selectedDay]?.attended || [], moduleName)}
                >Download CSV</button>
                <PDFDownloadLink
                  document={<PDFDocument students={dayWiseList[selectedDay]?.attended || []} moduleName={moduleName} />}
                  fileName={`${moduleName}-daywise-attended.pdf`}
                >
                  {({ loading }) => (
                    <button className="px-6 py-2 font-semibold text-white bg-green-500 rounded hover:bg-green-600">
                      {loading ? "Loading..." : "Download PDF"}
                    </button>
                  )}
                </PDFDownloadLink>
                <button
                  className="px-6 py-2 font-semibold text-white bg-purple-500 rounded hover:bg-purple-600"
                  onClick={() => handleSendEmail(dayWiseList[selectedDay]?.attended || [], moduleName)}
                >Share Now</button>
              </div>
            </div>
            <div id="daywise-attended-table">
              <table className="w-full text-sm text-left text-gray-700">
                <thead>
                  <tr className="text-xs text-gray-500 uppercase bg-blue-50">
                    <th className="px-2 py-2">S.No</th>
                    <th className="px-2 py-2">Name</th>
                    <th className="px-2 py-2">Roll No</th>
                    <th className="px-2 py-2">No. of Qs</th>
                    <th className="px-2 py-2">No. of Qs Attended</th>
                    <th className="px-2 py-2">Cluster</th>
                  </tr>
                </thead>
                <tbody>
                  {dayWiseList[selectedDay]?.attended?.map((student, idx) => (
                    <React.Fragment key={idx}>
                      <tr className="hover:bg-blue-50">
                        <td className="px-2 py-2 font-bold text-center">{idx + 1}</td>
                        <td className="px-2 py-2 font-medium">{student.name}</td>
                        <td className="px-2 py-2">{student.roll}</td>
                        <td className="px-2 py-2 text-center">15</td>
                        <td className="px-2 py-2 text-center">15</td>
                        <td className="px-2 py-2">{clusterName}</td>
                      </tr>
                      <tr>
                        <td colSpan={6}><hr className="border-gray-200 my-0.5" /></td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {viewTab === 1 && view === 4 && (
          <div className="p-8 mb-10 bg-white shadow-lg rounded-xl">
            <div className="flex flex-row items-center justify-between mb-6">
              <span className="inline-block px-3 py-1 text-lg font-bold text-blue-700 rounded-full">Daywise Not Attended Students</span>
              <div className="flex flex-row justify-end gap-4">
                <button
                  className="px-6 py-2 font-semibold text-white bg-blue-900 rounded hover:bg-blue-800"
                  onClick={() => setView(3)}
                >Attended</button>
                <button
                  className="px-6 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
                  onClick={() => downloadCSV(dayWiseList[selectedDay]?.notAttended || [], moduleName)}
                >Download CSV</button>
                <PDFDownloadLink
                  document={<PDFDocument students={dayWiseList[selectedDay]?.notAttended || []} moduleName={moduleName} />}
                  fileName={`${moduleName}-daywise-not-attended.pdf`}
                >
                  {({ loading }) => (
                    <button className="px-6 py-2 font-semibold text-white bg-green-500 rounded hover:bg-green-600">
                      {loading ? "Loading..." : "Download PDF"}
                    </button>
                  )}
                </PDFDownloadLink>
                <button
                  className="px-6 py-2 font-semibold text-white bg-purple-500 rounded hover:bg-purple-600"
                  onClick={() => handleSendEmail(dayWiseList[selectedDay]?.notAttended || [], moduleName)}
                >Share Now</button>
              </div>
            </div>
            <div id="daywise-not-attended-table">
              <table className="w-full text-sm text-left text-gray-700">
                <thead>
                  <tr className="text-xs text-gray-500 uppercase bg-blue-50">
                    <th className="px-2 py-2">S.No</th>
                    <th className="px-2 py-2">Name</th>
                    <th className="px-2 py-2">Roll No</th>
                    <th className="px-2 py-2">No. of Qs</th>
                    <th className="px-2 py-2">No. of Qs Attended</th>
                    <th className="px-2 py-2">Cluster</th>
                  </tr>
                </thead>
                <tbody>
                  {dayWiseList[selectedDay]?.notAttended?.map((student, idx) => (
                    <React.Fragment key={idx}>
                      <tr className="hover:bg-blue-50">
                        <td className="px-2 py-2 font-bold text-center">{idx + 1}</td>
                        <td className="px-2 py-2 font-medium">{student.name}</td>
                        <td className="px-2 py-2">{student.roll}</td>
                        <td className="px-2 py-2 text-center">15</td>
                        <td className="px-2 py-2 text-center">15</td>
                        <td className="px-2 py-2">{clusterName}</td>
                      </tr>
                      <tr>
                        <td colSpan={6}><hr className="border-gray-200 my-0.5" /></td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Day-wise Details removed as per request */}
      </div>
    </AdminLayout>
  );
};

export default ReportList;
